export default __webpack_public_path__ + "static/media/universe.a3e87f10.png";